import { ActionContext } from "vuex";

import { ISettingsModel, IUserModel } from "@/models";
import { RestClient } from "@elite/restclient";
import { IValidationRules } from "@elite/validation";

import IAppState from "../IAppState";
import { AppMutationTypes } from "../mutations";
import AppActionTypes from "./AppActionTypes";
import IAppActionTree from "./IAppActionTree";

export type GetUser = () => Promise<void>;
export type GetSettings = () => Promise<void>;
export type GetValidationRules = () => Promise<void>;

const restClient = new RestClient(process.env.VUE_APP_API_BASE_URL);

const actions: IAppActionTree = {
    async getSettings(
        context: ActionContext<IAppState, IAppState>
    ): Promise<void> {
        const response = await restClient.getJson<ISettingsModel>(
            "/api/Setting"
        );

        context.commit(AppMutationTypes.setSettings, response.data);
    },

    async getValidationRules(
        context: ActionContext<IAppState, IAppState>
    ): Promise<void> {
        const response = await restClient.getJson<IValidationRules>(
            "/api/ValidationRule"
        );
        context.commit(AppMutationTypes.setValidationRules, response.data);
    },

    async getUser(context: ActionContext<IAppState, IAppState>): Promise<void> {
        if (context.state.user?.id || !context.state.token) {
            return;
        }
        const response = await restClient.getJson<IUserModel>("/api/User");
        context.commit(AppMutationTypes.setUser, response.data);
    }
};

export default actions;

export { AppActionTypes, restClient };
